import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router';
import { EmailService } from 'src/app/services/email.service';
import Swal from 'sweetalert2';

import { UserService } from '../../services/user.service';
import { DomainService } from 'src/app/services/domain.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.styles.css']
})
export class RegisterComponent implements OnInit {

  public registerForm = this.fb.group({
    email: ['', Validators.email],
    password: ['', Validators.required],
    confPassword: ['', Validators.required],
    confEmail:['', Validators.required]

  });

  public working = false;

  constructor( 
    private fb : FormBuilder, 
    private userService : UserService, 
    private emailService:EmailService, 
    private route:ActivatedRoute,
    public domainService: DomainService
    
    ) { }

  ngOnInit(): void {
    this.domainService.inirService();
    var action = this.route.snapshot.queryParamMap.get("action");
    if (action) {
      sessionStorage.setItem("action",action);
    }
    var myInput = document.getElementById('not-paste');
    var myInput2 = document.getElementById('not-copy');

    myInput.onpaste = function(e) {
      e.preventDefault();
      Swal.fire('Por favor, completa estos campos sin copiar y pegar');
    }
    
    myInput2.oncopy = function(e) {
      e.preventDefault();
      Swal.fire('Por favor, completa estos campos sin copiar y pegar');
    }

  }

  register(){

    if (this.registerForm.value.password===this.registerForm.value.confPassword&&this.registerForm.value.email===this.registerForm.value.confEmail && !this.working){
      this.working = true;
      this.userService.register(this.registerForm.value).subscribe(
        res=>{
          var data = {
            email:this.registerForm.get('email').value,
            password:this.registerForm.get('password').value
          }
          this.emailService.clientRegister(data).subscribe();
          Swal.fire('Usuario creado',"Ingrese con sus credenciales", 'success');
          this.registerForm.reset();
          this.working = false;
        },
        err=>{
          Swal.fire('Error',err.error, 'error');
          // this.registerForm.reset();
          this.working = false;
        }
          )
    }else{
      Swal.fire('Error',"Revise su contraseña y su email", 'error');
    }
  }

  campoNoValido(campo:string){
    if (this.registerForm.get(campo).invalid && this.registerForm.get(campo).touched){
      return true;
    }else return false;
  }

}
